export default __webpack_public_path__ + "static/media/Logo_Personal_Mind_Plan2.13a89a4d.svg";